<template>
  <div v-if="getCurrentSelfBook" class="location_wrap">
    <div class="location">
      <span>{{ $t('selfbook.location.8216') }}</span>
      <span class="svg_next">></span>
      <div v-on-clickaway="closeListMenu" class="current">
        <div class="select_area" @click.prevent.stop="toggleListMenu">
          <div :class="{ active: isListMenuOpen }" class="select_item">
            <button type="button" class="select_option">
              <span class="txt">{{
                $route.name === 'selfbook_detail'
                  ? $t('selfbook.location.1917')
                  : $t('common.mobilesidebar.7229')
              }}</span
              ><span class="arrow blind">열기</span>
            </button>
            <ul class="select_list">
              <li>
                <router-link
                  :to="{
                    name: 'selfbook_detail',
                    params: { id: getCurrentSelfBook.id }
                  }"
                  >{{ $t('selfbook.location.1917') }}</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'selfbook_create' }">{{
                  $t('selfbook.location.21')
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelfbookLocation',
  data() {
    return {
      isListMenuOpen: false
    }
  },
  computed: {
    ...mapGetters(['getCurrentSelfBook'])
  },

  methods: {
    toggleListMenu() {
      this.isListMenuOpen = !this.isListMenuOpen
    },
    closeListMenu() {
      this.isListMenuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
